(function () {
    angular
        .module('smartertoolsApp')
        .service('ticketService', ['$http', 'refreshToken', '$q', ticketService]);

    function ticketService($http, refreshToken, $q) {
        let settingsPromise;
        let attsPromise;
        let sizePromise;
        let refreshPromise;
        let replyPromise;
        let bodyPromise;
        let msgsPromise;
        const vm = this;
        vm.urlBase = apiRootUrl;

        // Functions
        vm.getAccountSettings = getAccountSettings;
        vm.getMessageAttachments = getMessageAttachments;
        vm.getMessageBody = getMessageBody;
        vm.getMessages = getMessages;
        vm.refreshTicket = refreshTicket;
        vm.sendReply = sendReply;
        vm.submitTicket = submitTicket;
        vm.sendTicketAttachment = sendTicketAttachment;
        vm.getAllowedAttachmentSize = getAllowedAttachmentSize;
        activate();

        // -----------------------------------------------

        function activate() {
        }

        function getAccountSettings() {
            //if (settingsPromise)
            //	return settingsPromise;

            settingsPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.get(vm.urlBase + 'v1/account/details');
                })
                .then(function (response) {
                    settingsPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    settingsPromise = null;
                    $q.reject(err);
                });

            return settingsPromise;
        }

        function getMessageAttachments(ticketMessageId) {
            if (attsPromise)
                return attsPromise;

            attsPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase +
                        'v2/account/support/ticket/get-message-attachments/' +
                        ticketMessageId);
                })
                .then(function (response) {
                    attsPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    attsPromise = null;
                    $q.reject(err);
                });

            return attsPromise;
        }

        function getMessageBody(ticketMessageId) {
            if (bodyPromise)
                return bodyPromise;

            bodyPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/ticket/get-message/' + ticketMessageId);
                })
                .then(function (response) {
                    bodyPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    bodyPromise = null;
                    $q.reject(err);
                });

            return bodyPromise;
        }

        function getMessages(ticketNumber, ticketId) {
            if (msgsPromise)
                return msgsPromise;

            msgsPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/ticket/messages/' + ticketNumber + '/' + ticketId);
                })
                .then(function (response) {
                    msgsPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    msgsPromise = null;
                    $q.reject(err);
                });

            return msgsPromise;
        }

        function refreshTicket(ticketId) {
            if (refreshPromise)
                return refreshPromise;

            refreshPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/ticket-refresh/' + ticketId);
                })
                .then(function (response) {
                    refreshPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    refreshPromise = null;
                    $q.reject(err);
                });

            return refreshPromise;
        }

        function sendReply(details) {
            if (replyPromise)
                return replyPromise;

            replyPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/ticket/send-customer-message', JSON.stringify(details));
                })
                .then(function (response) {
                    replyPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    replyPromise = null;
                    $q.reject(err);
                });

            return replyPromise;
        }

        function submitTicket(details) {
            if (replyPromise)
                return replyPromise;

            replyPromise = refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/new-ticket', JSON.stringify(details));
                })
                .then(function (response) {
                    replyPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    replyPromise = null;
                    $q.reject(err);
                });

            return replyPromise;
        }

        function getAllowedAttachmentSize() {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.post(vm.urlBase + 'v2/account/support/ticket/get_allowed_attachment_max_size');
                })
                .then(function (response) {
                    sizePromise = null;
                    return response.data;
                })
        }

        function sendTicketAttachment(details) {
            return refreshToken.refreshToken()
                .then(function () {
                    const fileData = new FormData();
                    fileData.append('FileSize', details.FileSize);
                    fileData.append('TicketNumber', details.TicketNumber);
                    fileData.append('File', details.File);

                    return $http.post(vm.urlBase + 'v2/account/support/ticket/add-attachment', fileData, {
                        headers: {'Content-Type': undefined},
                        transformRequest: angular.identity
                    });
                })
                .then(function (response) {
                    return response.data;
                })
                .catch(function (err) {
                    $q.reject(err);
                });
        }
    }
})();